var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditdets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.6875,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4191 9.68413L15.6087 10.4945C15.5261 10.5771 15.3925 10.5771 15.3099 10.4945L13.3586 8.54327C13.276 8.46065 13.276 8.32705 13.3586 8.24443L14.169 7.43404C14.4978 7.10532 15.0322 7.10532 15.3626 7.43404L16.4191 8.49053C16.7496 8.81925 16.7496 9.35365 16.4191 9.68413ZM12.6625 8.94055L8.04628 13.5567L7.67361 15.6926C7.62263 15.9809 7.87401 16.2305 8.1623 16.1813L10.2981 15.8068L14.9144 11.1906C14.997 11.108 14.997 10.9744 14.9144 10.8918L12.9631 8.94055C12.8787 8.85793 12.7451 8.85793 12.6625 8.94055ZM9.84812 13.1612C9.75144 13.0645 9.75144 12.9098 9.84812 12.8132L12.5553 10.106C12.652 10.0093 12.8067 10.0093 12.9033 10.106C13 10.2027 13 10.3574 12.9033 10.4541L10.1962 13.1612C10.0995 13.2579 9.94481 13.2579 9.84812 13.1612ZM9.21352 14.6396H10.0573V15.2777L8.92347 15.4764L8.37676 14.9297L8.57541 13.7958H9.21352V14.6396Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.6875,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditdets);
export default __webpack_public_path__ + "static/media/editdets.34130e4e9b394f1798a07a629c98b065.svg";
export { ForwardRef as ReactComponent };